'use client'

import type { NotificationId } from '@gyym/sdk'
import { useEffect } from 'react'

import { markNotificationsAsRead } from '@/modules/Notifications'

// 一覧表示時に全件を既読化（localStorage）。Vue の created → markNotificationsAsRead 相当。
export const MarkNotificationsAsRead = ({ ids }: { ids: NotificationId[] }) => {
  const key = ids.join(',')

  useEffect(() => {
    void markNotificationsAsRead(ids)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return null
}
